export const tableColumns = [
  {
    title: '渠道用户名',
    dataIndex: 'channelUserName',
    width: '240px'
  },
  {
    title: '渠道URL',
    dataIndex: 'baseUrl',
    width: '240px'
  },
  {
    title: '渠道账号',
    dataIndex: 'channelAccount',
    width: '160px'
  },
  {
    title: '状态',
    dataIndex: 'statusName',
    width: '100px'
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    width: '180px'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '140px',
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]

export const editConfigList = [
  {
    name: '渠道用户名',
    key: 'channelUserName',
    placeholder: '请输入渠道用户名'
  },
  {
    name: '渠道URL',
    key: 'baseUrl',
    placeholder: '请输入渠道URL'
  },
  {
    name: '渠道账号',
    key: 'channelAccount',
    placeholder: '请输入渠道账号'
  },
  {
    name: '密码',
    key: 'password',
    placeholder: '请输入密码'
  }
]
